import React from "react";
import { useGetAllCategoryByProjectQuery } from "../../api/categoryApiSlice";
import FilterCategoryPresentation from "../../presentation/FilterCategoryPresentation/FilterCategoryPresentation";
import { FilterCategoryContainerProps } from "../../types/types";

const FilterCategoryContainer: React.FC<FilterCategoryContainerProps> = ({
  projectID,
  onSelectCategory,
  selectedDefault,
  page
}) => {
  const {
    data: categories,
    isLoading,
    // isError,
    // isSuccess,
  } = useGetAllCategoryByProjectQuery(projectID!);

  const onSelectCategoryValue = (value: string) => {
    if (value === 'All') {
      onSelectCategory(null)
    } else {
      onSelectCategory(categories?.entities[value]!)
    }
  }
  if (isLoading) {
    return <p>Loading...</p>
  }
  return (
    <>
      <>
        <FilterCategoryPresentation
          categories={categories!}
          onSelectCategory={onSelectCategoryValue}
          selectedDefault={selectedDefault}
          page={page}
        />
      </>
    </>
  )
}

export default FilterCategoryContainer
